module.exports = __webpack_public_path__ + "img/ctrl-p-stub-+i.38aead16.svg";